<template>
    <div>
      <div class="gite">
        <div class="gdf-WidgetBooking" data-source="owner" data-reference="H32G026866"></div>
      </div>
    </div>
</template>

<script>
export default {
    name: "reservationsGite",
    data() {
        return {
            showReservation: true,
        };
    },

    mounted() {
        const script3 = document.createElement('script');
        script3.src = "https://widget.cloudspire.io/booking/sdk.js";
        script3.async = true;
        document.head.appendChild(script3);
    },

    beforeDestroy() {
        const script3 = document.querySelector('script[src="https://widget.cloudspire.io/booking/sdk.js"]');
        if (script3) {
            script3.remove();
        }
    },

    watch: {},

    methods: {},
};
</script>

<style scoped>
.gite {
  margin: 5rem 11rem;
}

@media screen and (max-width: 450px) {
  .gite {
    margin: 0;
  }
}
</style>